export default {
  header: {
    logo: 'primary',
    eyebrowLogo: 'primary',
    eyebrowColour: 'dark',
    backgroundColour: 'dark',
    navigationAlignment: 'left'
  },
  siteConfig: {
    search: {
      placeholder: 'Series, Movies, Games...'
    }
  }
};